import { type FC } from "react";

import { faCircleCheck } from "@fortawesome/pro-duotone-svg-icons/faCircleCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Green confirmation banner used when the platform already owns data the
 * clinician might otherwise expect to upload. Introduced for the B0.5 → B3
 * follow-up flow to confirm that source PDFs from the prior comprehensive
 * are already stored.
 *
 * role="status" so screen readers announce it on arrival; the check icon is
 * decorative and hidden from assistive tech.
 */
export const SourcePdfBanner: FC<{
  title: string;
  description: string;
}> = ({ title, description }) => (
  <div
    role="status"
    className="mb-4 flex items-center gap-3 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3"
  >
    <FontAwesomeIcon
      icon={faCircleCheck}
      className="shrink-0 text-lg text-emerald-500"
      aria-hidden="true"
    />
    <div className="min-w-0">
      <div className="text-[13px] font-semibold text-emerald-800">{title}</div>
      <div className="mt-px text-[11px] text-emerald-700">{description}</div>
    </div>
  </div>
);
